module.exports = __webpack_public_path__ + "media/images/country_flags/mr-444001a041cd949786e4db4895387d41.png";